import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 29.5H23.5C25.1569 29.5 26.5 28.1569 26.5 26.5V10.9321C26.5 10.6563 26.3862 10.3928 26.1854 10.2039L18.2888 2.7718C18.1033 2.59721 17.8582 2.5 17.6034 2.5H8.5C6.84315 2.5 5.5 3.84315 5.5 5.5V26.5C5.5 28.1569 6.84315 29.5 8.5 29.5Z"
            fill="#C2EBD8"
            stroke="#397E54"
            strokeWidth="1.5"
        />
        <path
            d="M17.5 2.5V10C17.5 10.5523 17.9477 11 18.5 11H26.5"
            stroke="#397E54"
            strokeWidth="1.5"
        />
        <rect
            height="9"
            rx="1.5"
            stroke="#469565"
            width="15"
            x="8.5"
            y="17.5"
        />
        <rect
            fill="#397E54"
            height="0.5"
            rx="0.25"
            stroke="#469565"
            strokeWidth="0.5"
            width="14.5"
            x="8.75"
            y="14.25"
        />
        <rect
            fill="#397E54"
            height="0.5"
            rx="0.25"
            stroke="#469565"
            strokeWidth="0.5"
            width="5.5"
            x="8.75"
            y="10.25"
        />
        <rect
            fill="#397E54"
            height="0.5"
            rx="0.25"
            stroke="#469565"
            strokeWidth="0.5"
            width="5.5"
            x="8.75"
            y="8.25"
        />
        <rect
            fill="#397E54"
            height="0.5"
            rx="0.25"
            stroke="#469565"
            strokeWidth="0.5"
            width="5.5"
            x="8.75"
            y="6.25"
        />
    </svg>
);

export default Icon;
